import TweetRow from "../../../../src/components/articles/TweetRow";
import Typography from "@material-ui/core/Typography";
import DonateRow from "../../../../src/components/articles/DonateRow";
import NewsletterRow from "../../../../src/components/newsletter/NewsletterRow";
import FeaturedJobsSection from "../../../../src/components/jobs/FeaturedJobsSection";
import MakerOSSection from "../../../../src/components/ads/MakerOSSection";
import VideoComponent from "../../../../src/components/videos/VideoComponent";
import InlineAffiliateBanner from "../../../../src/tailwindComponents/InlineAffiliateBanner";
import * as React from 'react';
export default {
  TweetRow,
  Typography,
  DonateRow,
  NewsletterRow,
  FeaturedJobsSection,
  MakerOSSection,
  VideoComponent,
  InlineAffiliateBanner,
  React
};